import store from '../store'
import { createWt, addSteps } from './wt'

export const tour = createWt()

export const wtProducts = [
    {
        id: 1,
        dict_product_id: 11,
        name: 'BANANY STANDARD OPA 18 KG',
        ean: '60260093',
        alternative_ean: ''
    },
    {
        id: 2,
        dict_product_id: 12,
        name: 'CUKIERKI JAMAJKA BANAN & ANANAS VOBRO',
        ean: '5901177513865',
        alternative_ean: ''
    }
]

const steps = [
    {
        id: 1,
        title: 'Kody lokalne',
        text: 'Kliknij w przycisk "Dodaj produkt"',
        attachTo: {
            element: '.add-product',
            on: 'auto'
        },
        actionNext: () => {
            store.dispatch('openModal', {
                component: 'MerchantEanSelectionProducts',
                args: {
                    params: {
                        name: 'bana'
                    }
                }
            })
        }
    },
    {
        id: 2,
        title: 'Wyszukiwanie towarów',
        text:
            'Towary możesz wyszukać po nazwie lub po kodzie EAN. Po wyszukaniu interesującego Cię produktu kliknij "Uzupełnij"',
        attachTo: {
            element: '.modal-content',
            on: 'auto'
        },
        actionPrev: () => {
            store.dispatch('toggleModal', false)
        },
        actionNext: () => {
            store.dispatch('openModal', {
                component: 'AlternativeEans',
                args: {
                    dictProduct: wtProducts[0],
                    selectionProductsParams: {
                        name: 'bana'
                    }
                }
            })
        }
    },
    {
        id: 3,
        title: 'Uzupełnianie kodów lokalnych',
        text: `Jeśli jeden kod lokalny obowiązuje we wszystkich Twoich sklepach, uzupełnij górne pole i kliknij „Zastosuj dla wszystkich”. Jeśli kody lokalne różnią się między sklepami, uzupełnij odpowiednie pola przy danych sklepach. 
            <br /></br />
            Po uzupełnieniu kodów kliknij „Zapisz i uzupełnij kolejny”, jeśli chcesz kontynuować dodawanie kodów przy pozostałych towarach, lub „Zapisz i zamknij”, jeśli chcesz zakończyć.`,
        attachTo: {
            element: '.modal-content',
            on: 'bottom'
        },

        actionPrev: () => {
            store.dispatch('openModal', {
                component: 'MerchantEanSelectionProducts',
                args: {
                    params: {
                        name: 'bana'
                    }
                }
            })
        },

        when: {
            show: function() {
                const finishBtn = document.querySelector(
                    `[data-shepherd-step-id="${this.id}"] .walkthrough-next-step-btn`
                )
                finishBtn.id = 'tutorial-end-alt-eans'
            }
        }
    }
]

addSteps(tour, steps)

const handleHeader = onOpen => {
    const header = document.querySelector('.site-header__container')

    if (onOpen) {
        header.style.position = 'static'
    } else {
        header.style.removeProperty('position')
    }
}

tour.on('start', function() {
    document.body.classList.add('walkthrough')

    handleHeader(true)

    store.dispatch('setWalkthroughActive', true)
})

const cancelEvents = ['close', 'cancel', 'complete']

cancelEvents.forEach(event => {
    return tour.on(event, () => {
        document.body.classList.remove('walkthrough')

        handleHeader(false)

        store.dispatch('setWalkthroughActive', false)

        store.dispatch('toggleModal', false)
    })
})
